import { logError } from '../util';
import axios from 'axios';
import Config from '../../config';
export const FETCH_PHOTOBOOTH_MEDIA = 'FETCH_PHOTOBOOTH_MEDIA';
export const FETCH_PHOTOBOOTH = 'FETCH_PHOTOBOOTH';

const url =
	import.meta.env.MODE !== 'production' ? Config.arCamLocalServerUrl : Config.arCamServerUrl;

const fetchPhotoBoothMedia = (media, from) => ({
	type: FETCH_PHOTOBOOTH_MEDIA,
	media,
	from,
});

const fetchPhotoBooth = (photobooth, from) => ({
	type: FETCH_PHOTOBOOTH,
	photobooth,
	from,
});

const getImagebyId = async imageId => {
	try {
		const response = await axios.get(`${url}/api/image/id/${imageId}`);
		return response;
	} catch (error) {
		console.log(error);
	}
};

export const thunkFetchPhotoBoothMedia = (from, id) => async dispatch => {
	const serverUrl = `${url}/api/image/project/${id}`;
	try {
		const response = await axios.get(serverUrl);
		let media = [];
		for (const record of response.data.data) {
			let response = await getImagebyId(record.imageID);
			media.push(response.data.data[0]);
		}
		dispatch(fetchPhotoBoothMedia(media, from));
	} catch (error) {
		logError('media.actions.thunkFetchPhotoBoothMedia', error);
	}
};

export const thunkFetchPhotoBooth = (from, camId) => async dispatch => {
	const serverUrl = `${url}/api/assets/photobooth/${camId}`;
	try {
		const response = await axios.get(serverUrl);
		dispatch(fetchPhotoBooth(response.data.data, from));
	} catch (error) {
		logError('media.actions.thunkFetchPhotoBooth', error);
	}
};
